export default __webpack_public_path__ + "static/media/doctor.f7267ff1.svg";